export const inboxEnabled = (
  config?: {
    featureFlags?: { enableInbox?: boolean } | null;
  } | null
): boolean => Boolean(config?.featureFlags?.enableInbox);
